export default __webpack_public_path__ + "static/media/course-banner-blue.339b5ac0.jpg";